import React, { Component } from 'react';

import APIDocsBlock from '../APIDocsBlock';

export default class APIDocsPostsBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Posts</div>
          <div className="text">
            A post is an object that represents an idea posted to a board. They are always
            associated with a user and a board. Users can vote on them. The API allows you to fetch
            a specific post, or a list of posts for a&nbsp;board.
          </div>
        </div>
        <div></div>
      </APIDocsBlock>
    );
  }
}
